import autoComplete from "@tarekraafat/autocomplete.js";

export default class Autocomplete {

	static init() {
		return new Autocomplete();
	}

	constructor() {
        const autoCompleteInputs = document.querySelectorAll('.autocomplete');
        autoCompleteInputs.forEach((input) => {
            this.initAutocomplete(input);
        });
	}

    initAutocomplete(input) {
		const autoCompleteJS = new autoComplete({
            selector: () => {
                return input;
            },
            placeHolder: input.getAttribute('data-placeholder'),
            data: {
                src: async (query) => {
                    try {
                      const source = await fetch(input.getAttribute('data-src'));
                      const data = await source.json();
              
                      return data;
                    } catch (error) {
                      return error;
                    }
                },
                keys: input.getAttribute('data-keys').split(',')
            },
            resultItem: {
                element: (item, data) => {
                    item.classList.add('autocomplete-item');
                    item.innerHTML = `
                        <span class="text">${data.key == "name" ? data.match : data.value.name}</span>
                        <span class="type">${data.key == "symbol" ? data.match : data.value.symbol}</span>`;
                },
                highlight: true
            }
        });

        input.addEventListener('selection', () => {
            input.value = null;
            input.blur();
        });

        input.addEventListener('focus', () => {
            autoCompleteJS.start(' ');
        });
    }
}
